import React, { forwardRef } from 'react';

const SectionWrapper = forwardRef(({ children, className = "", id = "" }, ref) => {
  return (
    <section 
      ref={ref} 
      id={id} 
      className={`relative py-24 px-6 md:px-12 lg:px-24 mx-auto ${className}`}
    >
      {children}
    </section>
  );
});

export default SectionWrapper;
